import "./index.scss";

const SectionJoin = () => {};

export default SectionJoin;
